var g = "/static/8dbdba902ef088f6.png";

export { g as default };
//# sourceMappingURL=week_reload.png.js.map
